import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { FiDownload, FiX } from "react-icons/fi";

function CertificateQrModal({ certificateCode, qrDataUrl, onClose, t }) {
  const closeButtonRef = useRef(null);
  const previousFocusRef = useRef(null);

  useEffect(() => {
    previousFocusRef.current = document.activeElement;
    closeButtonRef.current?.focus();
    const onKeyDown = (event) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKeyDown);
    return () => { window.removeEventListener("keydown", onKeyDown); previousFocusRef.current?.focus?.(); };
  }, [onClose]);

  if (!qrDataUrl) return null;
  return <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/70 p-4" role="presentation" onMouseDown={onClose}>
    <section role="dialog" aria-modal="true" aria-labelledby="certificate-qr-title" className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onMouseDown={(event) => event.stopPropagation()}>
      <div className="flex items-start justify-between gap-4"><div><h2 id="certificate-qr-title" className="text-lg font-bold text-slate-900">{t("certificateVerification.qrCode")}</h2><p className="mt-1 text-sm text-slate-600">{certificateCode}</p></div><button ref={closeButtonRef} type="button" onClick={onClose} className="rounded-lg p-2 text-slate-600 hover:bg-slate-100" aria-label={t("certificateVerification.closePreview")}><FiX /></button></div>
      <img src={qrDataUrl} alt={`${t("certificateVerification.qrCode")} ${certificateCode}`} className="mx-auto my-5 h-72 w-72 max-w-full rounded-xl border bg-white p-2" />
      <div className="flex justify-end"><a href={qrDataUrl} download={`certificate-${certificateCode}-verification.png`} className="inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white"><FiDownload /> {t("certificateVerification.downloadQr")}</a></div>
    </section>
  </div>;
}

CertificateQrModal.propTypes = { certificateCode: PropTypes.string.isRequired, qrDataUrl: PropTypes.string, onClose: PropTypes.func.isRequired, t: PropTypes.func.isRequired };
CertificateQrModal.defaultProps = { qrDataUrl: "" };
export default CertificateQrModal;
